"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Keeps route changes pleasant without ever making page content depend on
 * IntersectionObserver or animation state. Public content must remain visible
 * when JavaScript is delayed, reduced motion is enabled, or a full-page
 * screenshot is captured.
 */
export function SmoothScroll({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const previous = document.documentElement.style.scrollBehavior;

    document.documentElement.style.scrollBehavior = reducedMotion
      ? "auto"
      : "smooth";

    return () => {
      document.documentElement.style.scrollBehavior = previous;
    };
  }, [pathname]);

  return <>{children}</>;
}
